import { render, staticRenderFns } from "./DirectOpen.vue?vue&type=template&id=6532af47"
import script from "./DirectOpen.ts?vue&type=script&lang=ts&external"
export * from "./DirectOpen.ts?vue&type=script&lang=ts&external"
import style0 from "./DirectOpen.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports